import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { BASE_URL } from '../Config/Base';

const FoundSectionHomeMain = () =>{

    useEffect(()=>{

    GetAddressFS();
    GetAddressDWH();
    GetAddressWWH();
    GetAddressBPF();
    GetAddressCB();
    GetAddressCU();
  
    })


  function GetAddressFS(){

    fetch(`${BASE_URL}/Foundation/GetFSTable`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data);
        // setAddress(data);
        // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("paginationDataFS", JSON.stringify(data));
          }
      );
  
    }  


    
  function GetAddressDWH(){

    fetch(`${BASE_URL}/Foundation/GetDWHTable`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data);
        // setAddress(data);
        // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("paginationDataDWH", JSON.stringify(data));    
      }
      );
  
    } 
    
    function GetAddressWWH(){

      fetch(`${BASE_URL}/Foundation/GetWWHTable`, {
    
        method: 'GET',
    
        headers: {
    
          "Content-type": "application/json",
          "Accept": "application/json",
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    
        },
    
        //body:JSON.stringify(data)
    
      }).then(response => response.json())
    
        .then(data => {
          console.log("Data", data);
          //setAddresswwh(data);
          // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          localStorage.setItem("paginationDataWWH", JSON.stringify(data));   
        }
        );
    
      }  

    
  function GetAddressBPF(){

    fetch(`${BASE_URL}/Foundation/GetBPFTable`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data);
       //setAddress(data);
        // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("paginationDataBPF", JSON.stringify(data));
          }
      );
  
    }  

    function GetAddressCB(){

      fetch(`${BASE_URL}/Foundation/GetContributorsTable`, {
    
        method: 'GET',
    
        headers: {
    
          "Content-type": "application/json",
          "Accept": "application/json",
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    
        },
    
        //body:JSON.stringify(data)
    
      }).then(response => response.json())
    
        .then(data => {
          console.log("Data", data);
          //setAddress(data);
          // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          localStorage.setItem("paginationDataCB", JSON.stringify(data));
        }
        );
    
      }  

      function GetAddressCU(){

        fetch(`${BASE_URL}/Foundation/GetContactAddress`, {
      
          method: 'GET',
      
          headers: {
      
            "Content-type": "application/json",
            "Accept": "application/json",
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      
          },
      
          //body:JSON.stringify(data)
      
        }).then(response => response.json())
      
          .then(data => {
            console.log("Data", data);
            //setAddress(data);
            // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
            localStorage.setItem("paginationDataCU", JSON.stringify(data));  
          }
          );
      
        }
        
        
  

  return (

    <div className='foundation-addmain mainimage'>

    <div className="foundation-addgrid-layout"> 
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/FoundSection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Home</span>
    </div>
    </div>
 
    <div className='section-responsive'>
    <div className='foundation-section' id="section-menu" >

    <ul>
       
    <li><Link to="/FoundSectionFS"><button className='foundation-sec-button' type='submit'>Slider Images &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    <li><Link to="/FoundSectionDWH"><button className='foundation-sec-button' type='submit'>Difference we have made &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    <li><Link to="/FoundSectionWWH"><button className='foundation-sec-button' type='submit'>Where we have been &nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    <li><Link to="/FoundSectionBPF"><button className='foundation-sec-button' type='submit'>Be a part of future &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    <li><Link to="/FoundSectionContributors"><button className='foundation-sec-button' type='submit'>Contributors &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    <li><Link to="/FoundSectionContact"><button className='foundation-sec-button' type='submit'>Contact us &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    </ul>
    
    </div>
    </div>
    
    </div>
  )
}

export default FoundSectionHomeMain
